import { render, staticRenderFns } from "./ForecastSelectViewToxinCells.vue?vue&type=template&id=f32f0230&scoped=true&"
import script from "./ForecastSelectViewToxinCells.vue?vue&type=script&lang=js&"
export * from "./ForecastSelectViewToxinCells.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f32f0230",
  null
  
)

export default component.exports